import { Table as ChakraTable, Flex, Icon } from "@chakra-ui/react";
import { ArrowUpIconSM, ArrowDownIconSM, SortIcon } from "@digital-services-gard-as/anchor-icons";
import { Table, flexRender } from "@tanstack/react-table";

type TableContentProps<T> = {
    table: Table<T>;
    children: React.ReactNode;
};
// prettier-ignore
const TableContent = <T, >({ table, children }: TableContentProps<T>) => (
    <ChakraTable.Root maxW="100%" boxSizing="border-box" whiteSpace="normal">
        <ChakraTable.Header
            position="sticky"
            top={0}
            zIndex={1}
            bg="anchor.white"
            borderBottom="1px"
            borderColor="anchor.gray.100"
            h="3rem"
            maxW="100%"
        >
            {table.getHeaderGroups().map(headerGroup => (
                <ChakraTable.Row
                    key={headerGroup.id}
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                    h="1.5rem"
                    maxW="100%"
                >
                    {headerGroup.headers.map(header => {
                        return (
                            <ChakraTable.ColumnHeader
                                key={header.id}
                                colSpan={header.colSpan}
                                textTransform="none"
                                h="1.5rem"
                                fontSize={"md"}
                                fontWeight="bold"
                                onClick={header.column.getToggleSortingHandler()}
                                bg={header.column.getIsSorted() ? "anchor.brown.100" : "anchor.white"}
                                w={header.getSize() + "rem"}
                                minW={header.column.id === "navigation" ? "3rem" : "10rem"}
                                wordBreak="break-word"
                                whiteSpace="normal"
                                data-testid={header.column.id + "Header"}
                            >
                                {header.isPlaceholder ? null : (
                                    <Flex
                                        className={header.column.getCanSort() ? "cursor-pointer select-none" : ""}
                                        onClick={header.column.getToggleSortingHandler()}
                                        gap="1rem"
                                        alignItems="center"
                                        maxW="100%"
                                    >
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                        {{
                                            asc: <ArrowUpIconSM />,
                                            desc: <ArrowDownIconSM />
                                        }[header.column.getIsSorted() as string] ?? null}
                                        {header.column.getCanSort() && !header.column.getIsSorted() && (
                                            <Icon fontSize="1.5rem">
                                                {" "}
                                                <SortIcon color="anchor.gray.300" />
                                            </Icon>
                                        )}
                                    </Flex>
                                )}
                            </ChakraTable.ColumnHeader>
                        );
                    })}
                </ChakraTable.Row>
            ))}
        </ChakraTable.Header>
        <ChakraTable.Body fontSize={"16px"} maxW="100%" minW="10rem">
            {children}
        </ChakraTable.Body>
    </ChakraTable.Root>
);

export default TableContent;
